import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { deleteInArray, errorCatch, GET, Model, POST, QueryDetail, QueryOrder, updateInArray } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import MDEditor, { } from "@uiw/react-md-editor";
import ModernUserSelection from '../../components/ModernUserSelection';
import User from '../../../common/User';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


var _ = require('lodash');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        // display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function FederationadministratorPostsVkgroups(props) {
    const classes = useStyles();
    const { auth } = props;

    const filters = () => [
        {
            name: "nazvanie",
            sort: true,
            filter: true,
        },
        {
            name: "ssilka",
            sort: true,
            filter: true,
        },
        {
            name: "vkId",
            sort: true,
            filter: true,
        },
        {
            name: "key",
            sort: true,
            filter: true,
        },
        {
            name: "prioritet",
            sort: true,
            filter: true,
        },
        // {
        //     name: "user.lastname",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "user.firstname",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "user.patronymic",
        //     sort: true,
        //     filter: true,
        // },

        // {
        //     name: "user.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Телефон",
        //     name: "user.phone",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "user.gender",
        //     sort: true,
        //     filter: true,
        //     display: (o) => o.name,
        // },
        // {
        //     label: "Дата создания",
        //     name: "user.createdAt",
        //     type: "date",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Тип счета",
        //     name: "akkauntType",
        //     filterType: "group",
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryOrder("code", "ASC"),
        //         // QueryParam("w-in-id", "2,9")
        //         QueryParam("w-neq-id", "7")
        //     ],
        //     display: (o) => o.opisanie,
        //     sort: true,
        //     filter: true,
        //     // filtered: [2],
        // },
        // {
        //     label: "Баланс счета",
        //     name: "ostatok",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Номер счета",
        //     name: "nomerAkkaunta",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
        //     name: "accountInfo.vladelets",
        //     // queryComparer:"swsim", // sim, wsim, swsim
        //     sort: true,
        //     filter: true,
        // },
    ];

    const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => {
        return (<div key={item.ID || idx} style={{ width: "100%" }}>
            <div className={classes.item} style={{display:"flex", alignItems:"center", gap:"5px"}}>
                {/* <User item={item?.user} noborder={true} /> */}
                <div className='bg bg-grey' style={{flex:"0 0 50px", fontSize:"12px" }}>{item?.prioritet}</div>
                <div style={{flex:"1 1 auto"}}>{item?.nazvanie}</div>
            </div>
        </div>)
    }

    // "/api/vkgroups/create"
    // "/api/vkgroups/update"
    // "/api/vkgroups/delete/{id}"
    // "/api/vkgroups/list"
    // "/api/vkgroups/byid/{id}"

    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingBottom: "15px", fontSize: "18px" }}>Группы VK</div>
                </div>
                <CollectionServer
                    auth={auth}
                    name={"VkGroups"}
                    // queryDetail={"collection"}
                    source={"/api/vkgroups/list"}
                    filters={filters}
                    size={"small"}
                    mode={"list"}
                    // title="Создатели постов"
                    render={render}

                    collectionActions={() => [{
                        auth: auth,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, `/api/vkgroups/create`, values,
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data, true));
                                    close();
                                }, (err) => errorCatch(err, unlock)
                            );
                        },
                        title: "Создать",
                        modal: {
                            title: "Создание группы в VK",
                            width: "650px"
                        },
                        // form: ModernUserSelection,
                        form: Model,
                        meta: [
                            {
                                label: "Название",
                                name: "nazvanie",
                                type: "string",
                            },
                            {
                                label: "Ссылка",
                                name: "ssilka",
                                type: "string",
                            },
                            {
                                label: "Идентификатор ВК",
                                name: "vkId",
                                type: "int",
                            },
                            {
                                label: "Ключ",
                                name: "key",
                                type: "string",
                            },
                            {
                                label: "Приоритет",
                                name: "prioritet",
                                type: "int",
                            },
                        ],
                    }]}
                    modelActions={(item) => {
                        return [
                            {
                                auth: auth,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, `/api/vkgroups/update`, { ...values, ID: item?.ID },
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data, true));
                                            close();
                                        }, (err) => errorCatch(err, unlock)
                                    );
                                },
                                title: "Изменить",
                                modal: {
                                    title: "Изменение группы в VK",
                                    width: "650px"
                                },
                                form: Model,
                                meta: [
                                    {
                                        label: "Название",
                                        name: "nazvanie",
                                        type: "string",
                                    },
                                    {
                                        label: "Ссылка",
                                        name: "ssilka",
                                        type: "string",
                                    },
                                    {
                                        label: "Идентификатор ВК",
                                        name: "vkId",
                                        type: "int",
                                    },
                                    {
                                        label: "Ключ",
                                        name: "key",
                                        type: "string",
                                    },
                                    {
                                        label: "Приоритет",
                                        name: "prioritet",
                                        type: "int",
                                    },
                                ],
                            },
                            {
                                auth: auth,
                                title: <span style={{ color: "red" }}>Удалить</span>,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    confirmKey({
                                        pass: '123',
                                        title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить группу</span>,
                                        icon: undefined,
                                        content: <div>
                                            <div>Вы действительно хотите удалить группу?</div>
                                            <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.nazvanie} </div>
                                        </div>,
                                        okText: 'Удалить',
                                        cancelText: 'Отмена',
                                        onOk() {
                                            return new Promise((resolve, reject) => {
                                                GET(auth, '/api/vkgroups/delete/' + item.ID,
                                                    ({ data }) => {
                                                        setCollection(deleteInArray(collection, item));
                                                        resolve(data);
                                                    }, (err) => errorCatch(err, reject));
                                            }).catch(() => { });
                                        },
                                        onCancel() {
                                        },
                                    })
                                }
                            }
                        ]
                    }}
                />
            </div>
        </PageLayout>

    );
}
